const QUIZES = "quizes";
const STATUS = {
    PASSED: "passed",
    COMPLETED: "completed",
    FAILED: "failed",
    INCOMPLETE: "incomplete",
    BROWSED: "browsed",
    NOT_ATTEMPTED: "not attempted"
};

const SCORM_API = {
    SUSPEND_DATA: "cmi.suspend_data",
    LESSON_STATUS: "cmi.core.lesson_status",
    LESSON_LOCATION: "cmi.core.lesson_location",
    SCORE: "cmi.core.score.raw"
};

class LocstorService {
    constructor() {
        this.name = 'localStorage';
    }

    init() {
        return true;
    }

    get(key) {
        return localStorage.getItem(key);
    }

    set(key, value) {
        localStorage.setItem(key, value);
        return true;
    }
    getObject(key) {
        let value = this.get(key);
        console.log(typeof(value))
        console.log(value.length)
        

        console.log(key, value); 
        return JSON.parse(value != null && value.length > 2 ? value : "{}");
    }
    setObject(key, value) {
        this.set(key, JSON.stringify(value));
        return true;
    }
    save() {
        console.log('trying to save...');
        return true;
    }
    quit() {
        console.log('trying to quit...');
    }
}
class PersistanceFake {
	static Create() {
		return new PersistanceFake();
	}
	constructor() {
		this.name = "PersistanceFake";
		this.db = {};
		console.log(`%c* Persistance - ${this.name} * `, "font-weight:bold; color:purple");
	}

	init() {
		return true;
	}

	get(key) {
		return this.db[key];
	}

	set(key, value) {
		this.db[key] = value;
		console.log("PersistanceFake >>", key, value);
	}

	save() {
		return true;
	}

	quit() {
		console.log("PersistanceFake >> quit");
		return true;
	}

	getObject(key) {
		return this.get(key);
	}

	setObject(key, value) {
		this.set(key, value);
	}

	saveObject(key, value) {
		let objects = this.getObject(SCORM_API.SUSPEND_DATA) || {};
		objects[key] = value;
		this.setObject(SCORM_API.SUSPEND_DATA, objects);
	}

	removeObject(key) {
		let objects = this.getObject(SCORM_API.SUSPEND_DATA) || {};
		delete objects[key];
		this.setObject(SCORM_API.SUSPEND_DATA, objects);
	}

	loadObject(key) {
		let objects = this.getObject(SCORM_API.SUSPEND_DATA) || {};
		return objects[key];
	}

	saveQuiz(key, value) {
		let quizes = this.loadObject(QUIZES) || {};
		quizes[key] = value;
		this.saveObject(QUIZES, quizes);
	}

	loadQuiz(key) {
		let quizes = this.loadObject(QUIZES) || {};
		return quizes[key];
	}

	getQuizCollection() {
		return this.loadObject(QUIZES);
	}

	setCompleted() {
		this.setLessonStatus(STATUS.COMPLETED);
	}

	setLessonStatus(status) {
		this.set(SCORM_API.LESSON_STATUS, status);
	}
}
class PersistanceService {
	static Create() {
		pipwerks.debug.isActive = false;
		return new PersistanceService(new ScormAPIService(), new LocstorService());
	}
	constructor(scorm, locstor) {
		this.scorm = scorm;
		this.locstor = locstor;
		this.persistance = this.scorm.ready ? this.scorm : this.locstor;
		this.temp_suspend_data = null;
		
		// console.log(`%c* Persistance - ${this.persistance.name} * `, "font-weight:bold; color:purple");
	}
	// inicializa scorm
	init() {
		return this.persistance.init();
	}
	// retorna dados direto do scorm
	get(key) {
		// console.log("GET-PERSISTENCE", key);
		return this.persistance.get(key);
	}
	// salva dados direto no scorm
	set(key, value) {
		return this.persistance.set(key, value);
	}
	// commit do scorm
	save() {
		return this.persistance.save();
	}
	//scorm quit
	quit() {
		this.persistance.quit();
	}
	// retorna dados do scorm passados pelo JSON.parse
	getObject(key) {
		// console.log("GET-PERSISTENCE-OBJECT", key);
		return this.persistance.getObject(key);
	}
	// salva dados no scorm passados pelo JSON.stringify
	setObject(key, value) {
		return this.persistance.setObject(key, value);
	}

	saveObject(key, value) {
		let objects;

		if(this.temp_suspend_data == null){
			objects = this.persistance.getObject(SCORM_API.SUSPEND_DATA) || {};
			this.temp_suspend_data = objects;
		}else{
			objects = this.temp_suspend_data;
		}

		objects[key] = value;
		this.temp_suspend_data = objects;
		this.persistance.setObject(SCORM_API.SUSPEND_DATA, objects);
		
	}

	removeObject(key) {

		let objects;

		if(this.temp_suspend_data == null){
			objects = this.persistance.getObject(SCORM_API.SUSPEND_DATA) || {};
			this.temp_suspend_data = objects;
		}else{
			objects = this.temp_suspend_data;
		}

		delete objects[key];
		this.temp_suspend_data = objects;
		this.persistance.setObject(SCORM_API.SUSPEND_DATA, objects);
	}

	loadObject(key) {
		
		let objects;

		if(this.temp_suspend_data == null){
			objects = this.persistance.getObject(SCORM_API.SUSPEND_DATA) || {};
			this.temp_suspend_data = objects;
		}else{
			objects = this.temp_suspend_data;
		}

		return objects[key];
	}

	saveQuiz(key, value) {
		let quizes = this.loadObject(QUIZES) || {};
		quizes[key] = value;
		this.saveObject(QUIZES, quizes);
	}

	loadQuiz(key) {
		let quizes = this.loadObject(QUIZES) || {};
		return quizes[key];
	}

	getQuizCollection() {
		return this.loadObject(QUIZES);
	}

	setCompleted() {
		this.setLessonStatus(STATUS.COMPLETED);
		this.persistance.save();
	}

	setLessonStatus(status) {
		this.set(SCORM_API.LESSON_STATUS, status);
	}
}
class ScormAPIService {
    constructor() {
        this.name = 'scorm';
        this.scorm = pipwerks.SCORM;
        this.ready = this.init();
        this.hasDataToSave = false;
    }

    saveData(key, value) {
        this.suspend_data[key] = value;
        this.set(SCORM_API.SUSPEND_DATA, JSON.stringify(this.suspend_data));
    }

    getData(key) {
        //console.log("GET-DATA-SERVICE", key);
        return this.suspend_data[key];
    }

    init() {
        return this.scorm.init();
    }

    get(key) {
        //console.log("GET-SERVICE", key);
        return this.scorm.get(key);
    }

    set(key, value) {
        // console.log("SET-OBJECT-SERVICE", key);
        let response = this.scorm.set(key, value);
        this.hasDataToSave = true;

        return response;
    }

    getObject(key) {
        // console.log("GET-OBJECT-SERVICE", key);
        console.log(key, value);
        const value = this.get(key);
        return JSON.parse(value != null && value.length > 0 ? value : "{}");
    }

    setObject(key, value) {
        return this.set(key, JSON.stringify(value));
    }
    
    save() {

        if(this.hasDataToSave){
            this.hasDataToSave = false;
            this.scorm.save();
        }
        
    }

    quit() {
        this.scorm.quit();
    }
}